var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AbstractDropDown2 = _interopRequireDefault(require("./AbstractDropDown"));

var _Basic = require("../../../../elements/Basic");

var _index = _interopRequireDefault(require("../../../../i18n/index"));

var _FontelloIcon = _interopRequireDefault(require("../FontelloIcon"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Basic/DropDown/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var DropdownIndicator = function DropdownIndicator(props) {
  return _react.default.createElement(_FontelloIcon.default, {
    mr: 2,
    rotate: 90,
    name: "arrow-front",
    size: "arrowSize",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 5
    }
  });
};

var customSelectStyle = function customSelectStyle(disabled) {
  return {
    option: function option(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, {
        fontSize: 16,
        fontFamily: 'Sport1-Regular'
      });
    },
    input: function input(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, {
        fontSize: 16,
        fontFamily: 'Sport1-Regular'
      });
    },
    singleValue: function singleValue(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, {
        fontSize: 16,
        color: 'black',
        fontWeight: 'bold',
        fontFamily: 'Sport1-Regular'
      });
    },
    dropdownIndicator: function dropdownIndicator(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, {
        color: '#000',
        backgroundColor: disabled ? 'gray' : 'white'
      });
    },
    valueContainer: function valueContainer(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, {
        justifyContent: disabled ? 'flex-start' : 'center',
        backgroundColor: disabled ? 'gray' : 'white',
        alignItem: 'center'
      });
    },
    indicatorSeparator: function indicatorSeparator(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, {
        display: 'none'
      });
    },
    control: function control(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, {
        paddingRight: 8,
        borderRadius: '0px',
        backgroundColor: disabled ? 'gray' : 'white'
      });
    }
  };
};

var DropDown = function (_AbstractDropDown) {
  (0, _inherits2.default)(DropDown, _AbstractDropDown);

  var _super = _createSuper(DropDown);

  function DropDown() {
    var _this;

    (0, _classCallCheck2.default)(this, DropDown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.generateCustomSelectStyle = function () {
      var disabled = _this.props.disabled;

      if (!disabled && _this.props.customSelectStyle) {
        return (0, _extends2.default)(customSelectStyle(disabled), _this.props.customSelectStyle);
      }

      return customSelectStyle(disabled);
    };

    return _this;
  }

  (0, _createClass2.default)(DropDown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          disabled = _this$props.disabled,
          selectOptions = _this$props.selectOptions,
          dropdownIndicator = _this$props.dropdownIndicator,
          pickerStyle = _this$props.pickerStyle;
      var selectedIndex = this.state.selectedIndex;
      if (!selectOptions && !disabled) return null;
      return this.renderDropDown(_react.default.createElement(_Basic.View, (0, _extends2.default)({
        width: "100%"
      }, pickerStyle, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 87,
          columnNumber: 13
        }
      }), _react.default.createElement(_reactSelect.default, {
        isSearchable: false,
        options: !disabled ? selectOptions : [],
        value: !disabled ? selectOptions[selectedIndex] : {
          label: (0, _index.default)('inactive')
        },
        onChange: function onChange(item) {
          return _this2.onValueChange(item.value, item.index);
        },
        searchable: false,
        styles: this.generateCustomSelectStyle(),
        components: {
          DropdownIndicator: dropdownIndicator
        },
        borderRadius: 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 88,
          columnNumber: 17
        }
      })));
    }
  }]);
  return DropDown;
}(_AbstractDropDown2.default);

exports.default = DropDown;
DropDown.propTypes = {
  withArrows: _propTypes.default.bool,
  selectedIndex: _propTypes.default.number,
  selectOptions: _propTypes.default.instanceOf(Array).isRequired,
  customSelectStyle: _propTypes.default.object,
  dropdownIndicator: _propTypes.default.func,
  onValueChange: _propTypes.default.func,
  onLeft: _propTypes.default.func,
  onRight: _propTypes.default.func
};
DropDown.defaultProps = {
  disabled: false,
  pickerStyle: {},
  dropdownIndicator: DropdownIndicator
};